import React from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';

/*

Props:

*/
// display: flex;
// flex: 1 1 0%;
// flex-flow: column nowrap;

const StyledDiv = styled.div`
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  align-self: stretch;
  max-width: ${props => (props.maxWidth) ? props.maxWidth : '500'}px;
  /* height: calc(100vh - 73px); */
  align-content: stretch;
  border-left: 1px solid rgba(0, 0, 0, 0.14);
  border-right: 1px solid rgba(0, 0, 0, 0.14);
  min-width: 320px;
  max-height: 100%;
`;

const InteractionPanelOuterContainerSC = ({ style, onClick, children, ...rest }) => (
  <StyledDiv style = {style}  onClick = {onClick} constant={ constants } {...rest} >
      { children }
  </StyledDiv>
)

export default InteractionPanelOuterContainerSC;

// color: ${props => (props.color) ? props.color : 'red'};
//   box-shadow: -7px 11px 78px -24px rgba(0,0,0,0.16);


// WEBPACK FOOTER //
// ./src/js/components/InteractionComponents/InteractionPanelOuterContainerSC.jsx